import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  container: {
    maxWidth: '35rem',
    margin: 'auto',
  },
}));

const switchLabel = makeStyles((theme) => ({
  label: { fontWeight: 500, fontSize: 14 },
}));

export { useStyles, switchLabel };
